import React, { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { useWorkspaceContext } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/controllers/workspace-context/index.tsx';
import type {
	CmdbObjectId,
	CmdbObjectTypeId,
	SchemaId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import { type EntityType, trackView } from '../services/index.tsx';

const TrackView = ({ id, entityType }: { id: string; entityType: EntityType }) => {
	di(clearTimeout, setTimeout);

	const { workspaceId } = useWorkspaceContext();
	useEffect(() => {
		if (!workspaceId) {
			return () => undefined;
		}

		// Delay the track request to avoid contention with other requests for initial loading
		const trackTimeoutId = setTimeout(() => {
			trackView({ workspaceId, entityId: id, entityType }).catch((error) => {
				fireCmdbErrorAnalytics({
					error,
					meta: {
						id: 'TrackView',
						packageName: 'jiraServicedeskInsightUserHistoryTracker',
						teamName: 'aurum',
					},
					attributes: {
						entityId: id,
						entityType,
					},
				});
			});
		}, 1000);

		return () => clearTimeout(trackTimeoutId);
	}, [workspaceId, id, entityType]);

	return null;
};

export const TrackObjectView = ({ id }: { id: CmdbObjectId }): React.JSX.Element => (
	<TrackView id={id} entityType="object" />
);
export const TrackObjectTypeView = ({ id }: { id: CmdbObjectTypeId }): React.JSX.Element => (
	<TrackView id={id} entityType="object-type" />
);
export const TrackObjectSchemaView = ({ id }: { id: SchemaId }): React.JSX.Element => (
	<TrackView id={id} entityType="object-schema" />
);
